import React from 'react';

class Searchbar extends React.Component {
  render() {
    return (
      <div>
        <input type="text" />
      </div>
    )
  }
};

export default Searchbar



// WEBPACK FOOTER //
// ./src/components/Searchbar/index.js